// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2xB0F","text":"SelectPayment_text__9Ewd_","title":"SelectPayment_title__wa623","btn":"SelectPayment_btn__3ze0N"};